/**
 * 其知网 其说论坛
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/index/index' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>其说论坛</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.search" style="width:140px"  clearable placeholder="输入标题关键词"></el-input>
        <el-input size="small" v-model="formInline.author_name" style="width:140px" clearable placeholder="输入作者名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.status" style="width:140px" placeholder="请选择">
          <el-option v-for="type in status" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select size="small" v-model="formInline.cate_id" style="width:140px" placeholder="请选择">
          <el-option v-for="type in cate_id" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>


      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择发布开始时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择发布结束时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-document-add" @click="handleEdit">发布</el-button>
      </el-form-item> -->
      <!-- <el-form-item>
        <el-button size="small" type="danger" icon="el-icon-delete" @click="delAllProblem">删除</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
     <el-table-column prop="title" align="center" label="标题" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="content" align="center" label="内容" width="600" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="封面图" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
                <div v-if="scope.row.cover_img">
                　  <img :src="scope.row.cover_img" width="100%" height="100%" style="max-height: 70px;">
                </div>
            </template>
      </el-table-column>
      <el-table-column prop="author_name" align="center" label="作者" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="cate_name" align="center" label="模块" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status" :formatter="contactFormat" align="center" label="状态" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="发布时间" show-overflow-tooltip width="140">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="previewProbiem(scope.$index, scope.row)">预览</el-button>
          <el-button size="mini" @click="editProbiem(scope.$index, scope.row)">审核</el-button>
          <el-button size="mini" type="danger" @click="delProblem(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 删除单个 -->
    <el-dialog :title="title" :visible.sync="delFormVisible" width="50%" @click="closeDialog('delForm')">
        <el-form label-width="120px" :model="delForm" ref="delForm">
            <el-form-item label="删除理由">
                <el-input size="small" v-model="delForm.reason" auto-complete="off" type="textarea" placeholder="请填写删除理由"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitDelNews('delForm')">提交</el-button>
              <el-button size="mini" @click='closeDialog("delForm")'>取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

    <!-- 审核文章 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
        <el-form label-width="120px" :model="editForm" ref="editForm">
            <el-form-item label="审核意见" prop="status">
                <el-radio-group type="kind" v-model="editForm.status" @change="changeStatus"> 
                    <el-radio v-model="editForm.status" :label="2" style="font-size: 25px">通过</el-radio>
                    <el-radio v-model="editForm.status" :label="3">不通过</el-radio>
                </el-radio-group>
            </el-form-item>
            <div v-if="isShow">
              <el-form-item label="拒绝理由">
                  <el-input size="small" v-model="editForm.reason" auto-complete="off" type="textarea" placeholder="请填写理由"></el-input>
              </el-form-item>
            </div>
            <el-form-item>
                <el-button size="mini" type="primary" @click="submitEditNews('editForm')">提交</el-button>
                <el-button size="mini" @click='closeDialog("editForm")'>取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>


    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import { webPlatformList, webDelPlatform, webPlatformCategory, webDelCheckPlatform,
 webEditPlatform, webEditCheckPlatform, webDelProblem, webDelAllProblem, webEditProblem } from '../../api/webMG'
import Pagination from '../../components/Pagination'

//引入富文本 start
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
//引入富文本 end

// const apiUrl = "http://192.168.0.158/index.php";
const apiUrl = "https://zlbb.qzhip.com/index.php";
export default {
  data() {
    return {
      idShow: false,
      isShow: false,
      idCoverShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      dialogVisible: false, //控制预览图片显示与隐藏
      delFormVisible: false, // 控制删除显示与隐藏
      editFormVisible: false, // 控制审核显示与隐藏
      title: '用户详情',
      addTitle: '发布文章',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      editorOption: {},
      cate_id: [],
      status: [
        { key: '全部', value: 0 },
        { key: '待审核', value: 1 },
        { key: '已通过', value: 2 },
        { key: '未通过', value: 3 },
        { key: '已删除', value: 4 }
      ],
       formInline: {
        page: 1,
        ps: 10,
        status: 0,
        author_name: '',
        search: '',
        cate_id: 0,
        start_time: '',
        end_time: '',
        // token: localStorage.getItem('logintoken')
      },
      delForm: {
        reason: ''
      },
      editForm: {
        reason: '',
        status: 0 
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 表单验证
      addFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        author: [
          { required: true, message: '请输入作者', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择分类', trigger: 'blur' }
        ],
        cover_img: [
          { required: true, message: '请上传封面图', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      }
  
    }
  },
  // 注册组件
  components: {
    Pagination,
    quillEditor
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getCate()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webPlatformList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    getCate() {
      webPlatformCategory()
        .then(res => {
          this.loading = false
          console.log(res);
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.cate_id = res.data
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    contactFormat(row,column){
      if(row.status == 1){
          return '待审核'
      }else if(row.status == 2){
          return '已通过'
      }else if(row.status == 3){
          return '未通过'
      }else if(row.status == 4){
          return '已删除'
      }else{
          return '未定义'
      }
    },
    // 显示删除帖子dialog
    delProblem(index, row) {
        if(row.status == 4){
            this.$message({
                type: 'error',
                message: '该状态不支持!'
          })
          return false
        }
        this.title = '帖子删除'
        this.delFormVisible = true
        this.delForm.article_id = row.id
    },
    // 删除帖子
    submitDelNews() {
        if(this.delForm.reason.length <= 0){
            this.$message({
                type: 'error',
                message: '删除理由不能为空'
            })
            return false;
        }
          // 添加提示框，确定后再导出，防止乱点，减轻服务器压力
        this.$confirm('确定删除吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            webDelPlatform(this.delForm)
            .then(res=>{
              this.loading = false
              console.log(res);
              if (res.code == 200) {
                  this.$message({
                      type: 'success',
                      message: '删除成功'
                })
                  this.delForm.article_id = ''
                  this.delForm.reason = ''
                  this.delFormVisible = false
                  this.getdata(this.formInline)
              } else {
                  this.$message({
                      type: 'info',
                      message: res.msg
                })
              }
            })
            })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
    },
    delAllProblem(){
    // 判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
        //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除所有勾选的吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const idStr = JSON.stringify(idsArr)
        const delParam = {ids:idStr}
        webDelAllProblem(delParam)
        .then(res=>{
          this.loading = false
          console.log(res);
          if (res.code == 200) {
              this.$message({
                  type: 'success',
                  message: '删除成功'
            })
              this.getdata(this.formInline)
          } else {
              this.$message({
                  type: 'info',
                  message: res.msg
            })
          }
        })
        })
         .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 显示审核弹窗
    editProbiem(index, row) {
      if(row.status == 4){
        this.$message({
          type: 'error',
          message: '已删除无法审核'
        })
        return false
      }
      this.editForm.article_id = row.id
      this.editForm.status = row.status
      this.editFormVisible = true
      this.title = '文章审核'
      return false
    },
    submitEditNews() {
      webEditPlatform(this.editForm)
        .then(res=>{
          this.loading = false
          if (res.code == 200) {
              this.$message({
                  type: 'success',
                  message: res.msg
            })
              this.editFormVisible= false
              this.editForm.reason = ''
              this.getdata(this.formInline)
          } else {
              this.$message({
                  type: 'info',
                  message: res.msg
            })
          }
        })
    },
    // 文章预览
    previewProbiem(index, row) {
      let url = "https://www.qzhip.com/#/QishuoXq/"+row.id
      window.open(url,'_blank')
    },
    changeStatus(){
      if(this.editForm.status == 2){
        this.isShow = false
      }else if(this.editForm.status == 3){
        this.isShow = true
      }
      // console.log(this.editForm.type)
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
    if(formName == 'editForm'){
        this.editFormVisible = false
    }else if(formName == 'delForm'){
        this.delFormVisible = false
    }
      this.$refs[formName].resetFields()
    },
    // 图片上传成功
    handleAvatarSuccess(param){
      this.editForm.cover_img = param.data.url;
      console.log(param)
    },
    //图片上传超过数量限制
    handleExceed(files, fileList) {
      this.$message.error('文章封面只能上传一张!');
    },
    //图片上传失败调用
    imgUploadError(err, file, fileList){
      // console.log(err)
      this.$message.error('上传图片失败!');
    },
    //文件上传之前调用做一些拦截限制
    beforeAvatarUpload(file) {
      // console.log(file);
      const isJPG = true;
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    //移除图片
    handleRemove(file, fileList) {
      this.editForm.cover_img = '';
    },
    //预览图片时调用
    handlePictureCardPreview(file) {
      // console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/Platform.vue